/* eslint-disable no-unused-vars */
import {useState} from "react";
import {toast} from "sonner";
import {useUploadCourseMaterials} from "../hooks/useCourse";
import {Button} from "./button";

const CourseMaterialsUploader = ({courseId}) => {
  const [files, setFiles] = useState([]);
  const [titles, setTitles] = useState([]); // optional
  const uploadMaterials = useUploadCourseMaterials();

  const onChangeFiles = (e) => {
    const selected = Array.from(e.target.files || []);
    setFiles(selected);
    setTitles(selected.map((f) => f.name.replace(/\.pdf$/i, "")));
  };

  const handleTitleChange = (idx, value) => {
    setTitles((prev) => prev.map((t, i) => (i === idx ? value : t)));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!courseId) {
      toast.error("Course ID is required");
      return;
    }
    if (!files.length) {
      toast.error("Select at least one PDF");
      return;
    }

    const payload = {courseId, files, titles};
    toast.promise(uploadMaterials.mutateAsync(payload), {
      loading: "Uploading course materials...",
      success: (resp) => resp?.message || "Materials uploaded",
      error: "Failed to upload materials",
    });
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-4">
      <div>
        <input
          type="file"
          accept="application/pdf"
          multiple
          onChange={onChangeFiles}
        />
        <p className="text-xs text-gray-500 mt-1">
          Upload one or more PDF files.
        </p>
      </div>

      {!!files.length && (
        <div className="space-y-2">
          {files.map((f, idx) => (
            <div key={idx} className="flex items-center gap-2">
              <span className="text-sm">{f.name}</span>
              <input
                type="text"
                className="border rounded px-2 py-1 text-sm flex-1"
                value={titles[idx] || ""}
                onChange={(e) => handleTitleChange(idx, e.target.value)}
                placeholder="Display title (optional)"
              />
            </div>
          ))}
        </div>
      )}

      <Button type="submit">Upload PDFs</Button>
    </form>
  );
};

export default CourseMaterialsUploader;
